interface UserAttributedEntry {
  userId: string;
  userEmail: string | null;
}

/**
 * The "Felhasználó" filter choices, built from the log entries themselves so the diagnostic views
 * need no /api/admin/users call — that endpoint is ADMIN-only and an AUDITOR would be denied on it
 * (EW-65). Only users present in the current window are offered, so switching from one user to
 * another goes through "Összes felhasználó".
 */
export function userFilterOptions(
  entries: UserAttributedEntry[] | undefined,
  selectedUserId: string,
): { value: string; label: string }[] {
  const byId = new Map<string, string>();
  for (const e of entries ?? []) byId.set(e.userId, e.userEmail ?? e.userId.slice(0, 8));
  // Keep the active filter selectable even when the window holds none of its entries.
  if (selectedUserId && !byId.has(selectedUserId)) byId.set(selectedUserId, selectedUserId.slice(0, 8));
  return [
    { value: '', label: 'Összes felhasználó' },
    ...[...byId]
      .map(([value, label]) => ({ value, label }))
      .sort((a, b) => a.label.localeCompare(b.label, 'hu')),
  ];
}
